import { SET_MEDIA_LIBARY_MEDIA} from '../actions/actionCreators'
import { constructionPhoto, constructionVideo } from '../types/constructionMedia'

export interface mediaLibaryStateInput {
    data: constructionVideo[],
    count: number
}

export interface mediaLibaryState {
    videos: constructionVideo[],
    photos: constructionPhoto[],
    videosCount?: number
    phonosCount?: number
}

export type mediaLibaryActionTypes = 
  | {type: typeof SET_MEDIA_LIBARY_MEDIA; payload: mediaLibaryStateInput }

const reducer = (state:mediaLibaryState = {videos: [], photos: []},  action:mediaLibaryActionTypes) => {
    switch (action.type) {
    case SET_MEDIA_LIBARY_MEDIA:
        return {...state, videos: [...action?.payload?.data], videosCount: action?.payload?.count} 
    default:
        return state
    }
}
export default reducer
